import { combineReducers } from 'redux';

import activities from './activities.reducer';
import assets from './assets.reducer';
import assignedUsers from './assignedUsers.reducer';
import attendantCompanies from './attendantCompanies.reducer';
import aus from './aus.reducer';
import borrowers from './borrowers.reducer';
import chattelDetails from './chattelDetails.reducer';
import checklists from './checklists.reducer';
import closing from './closing.reducer';
import completenessChecklistIds from './completenessChecklistIds.reducer';
import completenessDesignationId from './completenessDesignationId.reducer';
import contacts from './contacts.reducer';
import controlUI from './controlUI.reducer';
import counties from './counties.reducer';
import customFieldValues from './customFieldValues.reducer';
import deal from './deal.reducer';
import disclosureActivity from './disclosureActivity.reducer';
import feeRecommendations from './feeRecommendations.reducer';
import financialInfo from './financialInfo.reducer';
import formTask from './formTask.reducer';
import generatedForm from './generatedForm.reducer';
import headerView from './headerView.reducer';
import housingFinanceAgencies from './housingFinanceAgencies.reducer';
import impounds from './impounds.reducer';
import incomes from './incomes.reducer';
import lead from './lead.reducer';
import liabilities from './liabilities.reducer';
import lienPriorities from './lienPriorities.reducer';
import loanActions from './loanActions.reducer';
import loanApplicationBorrowerCrmContacts from './loanApplicationBorrowerCrmContacts.reducer';
import loanApplicationBorrowerPendingContactLinks from './loanApplicationBorrowerPendingContactLinks.reducer';
import loanApplicationBorrowers from './loanApplicationBorrowers.reducer';
import loanApplicationChecklistResults from './loanApplicationChecklistResults.reducer';
import loanApplicationCommonInfoReducer from './loanApplicationCommonInfo.reducer';
import loanApplicationNonBorrowers from './loanApplicationNonBorrowers.reducer';
import loanApplicationProperties from './loanApplicationProperties.reducer';
import loanApplications from './loanApplications.reducer';
import loanApplicationTags from './loanApplicationTags.reducer';
import loanBundleHistory from './loanBundleHistory.reducer';
import loanChangesHistory from './loanChangesHistory.reducer';
import loanCicFeeReasons from './loanCicFeeReasons.reducer';
import loanCicFeeReasonsV2 from './loanCicFeeReasonsV2.reducer';
import loanCicReasons from './loanCicReasons.reducer';
import loanConditions from './loanConditions.reducer';
import loanConsents from './loanConsents.reducer';
import loanContacts from './loanContacts.reducer';
import loanDenial from './loanDenial.reducer';
import loanFeeCredits from './loanFeeCredits.reducer';
import loanFeeReasonHistory from './loanFeeReasonHistory.reducer';
import loanFees from './loanFees.reducer';
import loanKeyDates from './loanKeyDates.reducer';
import loanLodeStarQuestions from './loanLodeStarQuestions.reducer';
import loanOption from './loanOption.reducer';
import loanPrepaids from './loanPrepaids.reducer';
import loanProgramOptions from './loanProgramOptions.reducer';
import loanProgramOptionsDetails from './loanProgramOptionsDetails.reducer';
import loanRoles from './loanRoles.reducer';
import loanSellerAdjustments from './loanSellerAdjustments.reducer';
import loanSummary from './loanSummary.reducer';
import loanTags from './loanTags.reducer';
import lockedFields from './lockedFields.reducer';
import lockInfoAdjustments from './lockInfo.reducer';
import nonBorrowerEntities from './nonBorrowerEntities.reducer';
import nonUSLocations from './nonUSLocations.reducer';
import pendingChanges from './pendingChanges.reducer';
import pendingChangesAuthorsSelection from './pendingChangesAuthorsSelection.reducer';
import prepareDisclosuresWizard from './prepareDisclosuresWizard.reducer';
import pricingStatus from './pricingStatus.reducer';
import properties from './properties.reducer';
import propertyAndLoan from './propertyAndLoan.reducer';
import propertyEnrichment from './propertyEnrichment.reducer';
import rateSheets from './rateSheets.reducer';
import relatedLoans from './relatedLoans.reducer';
import residences from './residences.reducer';
import servicing from './servicing.reducer';
import stateSigningRequirements from './stateSigningRequirements.reducer';
import subjectProperty from './subjectProperty.reducer';
import submissionReadiness from './submissionReadiness.reducer';
import tasks from './tasks.reducer';
import taskSlaGroup from './taskSlaGroup.reducer';
import titleHolders from './titleHolders.reducer';
import trust from './trust.reducer';
import underwriting from './underwriting.reducer';
import uwReports from './uwReports.reducer';

const reducer = {
  loanApplication: combineReducers({
    assignedUsers,
    common: loanApplicationCommonInfoReducer,
    controlUI,
    pendingChanges,
    pendingChangesAuthorsSelection,
    attendantCompanies,
    assets,
    customFieldValues,
    borrowers,
    chattelDetails,
    loanApplicationBorrowers,
    loanApplicationBorrowerCrmContacts,
    loanApplicationBorrowerPendingContactLinks,
    loanApplicationNonBorrowers,
    nonBorrowerEntities,
    deal,
    incomes,
    liabilities,
    properties,
    subjectProperty,
    residences,
    tasks,
    taskSlaGroup,
    titleHolders,
    generatedForm,
    loanChangesHistory,
    lockInfoAdjustments,
    pricingStatus,
    loanOption,
    rateSheets,
    loanConsents,
    loanKeyDates,
    loanBundleHistory,
    disclosureActivity,
    loanConditions,
    uwReports,
    nonUSLocations,
    loanRoles,
    aus,
    loanFeeCredits,
    loanFees,
    feeRecommendations,
    loanLodeStarQuestions,
    loanSellerAdjustments,
    loanPrepaids,
    loanCicFeeReasons,
    loanCicFeeReasonsV2,
    loanFeeReasonHistory,
    loanCicReasons,
    counties,
    loanTags,
    lockedFields,
    formTask,
    underwriting,
    closing,
    lead,
    activities,
    headerView,
    contacts,
    loanActions,
    checklists,
    loanDenial,
    impounds,
    trust,
    financialInfo,
    propertyAndLoan,
    propertyEnrichment,
    loanProgramOptions,
    loanProgramOptionsDetails,
    loanSummary,
    submissionReadiness,
    loanApplicationChecklistResults,
    completenessChecklistIds,
    completenessDesignationId,
    loanApplicationProperties,
    loanApplicationTags,
    stateSigningRequirements,
    housingFinanceAgencies,
    lienPriorities,
    loanContacts,
    servicing,
    prepareDisclosuresWizard,
    relatedLoans,
  }),
  loanApplications,
};

export default reducer;
